import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import { BaseComponent } from '../../common/BaseComponent';
import { Webcam } from '../../components/webcam/webcam'
import Fab from 'preact-material-components/Fab';
import Icon from 'preact-material-components/Icon';
import { bind, memoize, debounce } from 'decko';
import Dialog from 'preact-material-components/Dialog';

let style = require('./style.css');

export class TakePictureComponent extends BaseComponent<any, any> {

    constructor(props?: any, ctx?: any) {
        super(props, ctx);

        this.state = {
            facing: "user",
            cameraIcon: "camera_front"
        };
    }

    public refs: {
        webcam?: Webcam,
        img?: HTMLImageElement,
        dialog?: Dialog
    } = {};

    @bind
    public onAccept() {
        fetch(this.refs.img.src)
            .then(res => res.blob())
            .then(blob => {

                var fd = new FormData();
                fd.append('files', blob, 'upload.jpg');

            });
    }

    @bind
    public takePicture() {
        this.refs.img.src = this.refs.webcam.getScreenshot();
        this.refs.dialog.MDComponent.show();
    }

    @bind
    public toggleCamera() {
        var facing = "environment";
        var cameraIcon = "camera_rear"
        if (this.state.facing == "environment") {
            facing = "user";
            cameraIcon = "camera_front";
        }
        this.setState({ facing: facing, cameraIcon: cameraIcon });
        console.log(facing);
        this.refs.webcam.reset();
    }

    render() {
        return (
            <div class={style.container}>
                <Webcam
                    width={1024}
                    height={768}
                    audio={false}
                    ref={this.setRef("webcam")}
                    screenshotFormat="image/jpeg"
                    facingMode={this.state.facing}
                    className={style.video}
                />
                <div class={style.buttonContainer}>
                    <Fab ripple={true} onClick={this.toggleCamera} style="margin-right:auto;">
                        <Icon>{this.state.cameraIcon}</Icon>
                    </Fab>
                    <Fab ripple={true} onClick={this.takePicture} style="margin:auto;">
                        <Icon>camera</Icon>
                    </Fab> 
                    <div style="margin-left:auto; width:56px;"></div>
                </div>
                <Dialog ref={this.setRef("dialog")} onAccept={this.onAccept}>
                    <Dialog.Header>Upload?</Dialog.Header>
                    <Dialog.Body>
                        <div>
                            <img class={style.capturedImage} ref={this.setRef("img")} />
                        </div>
                    </Dialog.Body>
                    <Dialog.Footer>
                        <Dialog.FooterButton cancel>Cancel</Dialog.FooterButton>
                        <Dialog.FooterButton accept>Ok</Dialog.FooterButton>
                    </Dialog.Footer>
                </Dialog>
                
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./routes/takePicture/takePicture.tsx